module.exports = __webpack_public_path__ + "static/media/air-filter.eb6f6946.svg";